export default "__VITE_ASSET__CzbONgMM__"